const CONFIRMATION_STRINGS = "replacement.confirmation";

export const ORDER_PLACED_ILLUSTRATION = "/img/lcr-order-placed.png";

/** Widest the confirmation column gets, matching the design frame. */
export const CONFIRMATION_COLUMN_MAX_WIDTH = 644;

/** Square size of the order-placed illustration. */
export const CONFIRMATION_ILLUSTRATION_SIZE = 128;

export const CONFIRMATION_STRING_KEYS = {
  heading: `${CONFIRMATION_STRINGS}.heading`,
  subcopy: `${CONFIRMATION_STRINGS}.subcopy`,
  orderNumberLabel: `${CONFIRMATION_STRINGS}.orderNumberLabel`,
  deviceLabel: `${CONFIRMATION_STRINGS}.deviceLabel`,
  deliveryMethodLabel: `${CONFIRMATION_STRINGS}.deliveryMethodLabel`,
  buildingLabel: `${CONFIRMATION_STRINGS}.buildingLabel`,
  addressLabel: `${CONFIRMATION_STRINGS}.addressLabel`,
  estimatedReadyLabel: `${CONFIRMATION_STRINGS}.estimatedReadyLabel`,
  backToMyHardware: `${CONFIRMATION_STRINGS}.backToMyHardware`,
} as const;
